import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { Subject,Observable }    from 'rxjs';
import { WordpressService } from './wordpress.service';
import {environment} from '../environments/environment';

@Injectable()
export class PlayerService implements OnInit {

  audio;
  audio_paused;

  audio_id;
  audio_title;
  audio_position;
  audio_status:string = "load";
  audio_elapsed;
  audio_duration;
  audio_url;
  audio_stopped;
  audio_autoplay:boolean = false;
  audio_buffered=null;
  public audio_icy="loading data..."

  metadataTimeout;

  public player_minimized:boolean = false;

  /* initApp */
  private _init_app = new Subject();
  init_app$ = this._init_app.asObservable();

  /* Metadata */
  private _icy_metadata = new Subject();
  icy_metadata$ = this._icy_metadata.asObservable();
  last_icy_metadata;

  /* Playing */
  private _audio_is_playing = new Subject();
  public audio_is_playing$ = this._audio_is_playing.asObservable();

  /* Time */
  private _audio_current_time = new Subject();
  public audio_current_time$ = this._audio_current_time.asObservable();

  private _podcast = new Subject();
  podcast$ = this._podcast.asObservable();
  posts$: Observable<any[]>;

  constructor(
    public http:HttpClient,
    private wp : WordpressService,
  ) {
    this.audio = new Audio();
    this.audio_paused = true; //audio not playing
    this._audio_is_playing.next(this.audio_paused);
    this.audio_stopped = true;
  }

  ngOnInit() {
    // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
    //end audio play
    this.audio_status = "init"
    this.audio.onended = this.handleEnded.bind(this);
    this.audio.oncanplay= this.handledCanPlay.bind(this);
    //play updates
    this.audio.ontimeupdate = this.handleTimeUpdate.bind(this);
    this.audio.onwaiting = this.handleWaiting.bind(this);
    this.audio.onloadedmetadata = this.handleLoadMetadata.bind(this);
  }

  load(url) {

    this.audio.src = url;
    this.audio.load();
    this.audio.ontimeupdate = this.handleTimeUpdate.bind(this);
    this.audio.onloadstart = () => {this.audio_buffered = 0;}
    this.audio.onended = () => { this.play(environment.urlStream) };
    this.audio.onprogress = this.onProgress()

    this.audio.oncanplay = () => {
      // init player
      this._init_app.next(true);

      this.audio_paused=false;
      this._audio_is_playing.next(this.audio_paused);

      if (url===environment.urlStream) {
        this.getStreamMetadata()
        this.metadataTimeout = setInterval( () => { this.getStreamMetadata()}, 5000 );
      } else {
        try {
            clearInterval(this.metadataTimeout)
        } catch (e) {
          console.error("Clear Interval Error: "+e)
        }
        //console.log(this.audio)
        // this._icy_metadata.next();
        // this._icy_metadata.next("Brba Podcast")
      }
      this.canPlay();
    };
  }

  public getStreamMetadata() {
    this.http.get<any[]>(environment.urlStreamMetadata)
    .subscribe( (res:any) => {
      let index
      try { index = res['icestats']['source'].findIndex( (source) => source.server_name == "brba.mp3" ) }
      catch (e) { index=0 }

      if (res['icestats']['source'][index]) {
        //console.log(res.icestats.source[index].title)
        this.audio_icy = res.icestats.source[index].title;
        this._icy_metadata.next(res.icestats.source[index].title);
        this.last_icy_metadata=res.icestats.source[index].title;
      }
    })
  }


  public podcast(p) {
    //console.log(p)
    this._icy_metadata.next(p[0].acf.icy_metadata_identifier);
    this._podcast.next(p)
  }

  public getIcyMetadata() {
    return this.audio_icy;
  }

  public getBuffered() {
    return Math.round(this.audio_buffered / this.audio.duration * 100);
  }

  onProgress() {

    var duration = this.audio.duration;

    if (duration > 0) {
      for (var i=0; i<this.audio.buffered.length; i++) {
        if (this.audio.buffered.start(this.audio.buffered.length - 1 - i) < this.audio.currentTime) {
          this.audio_buffered = this.audio.buffered.end(this.audio.buffered.length-1);

        }
      }
    }
  }

  play(url) {
    this.load(url);
  }

  // play(url?,title?,id?) {
  //   this.audio_stopped = true;
  //   // exite ya un audio en uso
  //   if (this.audio_id>0) {
  //     //si le volvemos a enviar el id comprobamos si hay que cambiar
  //     if (!!id) {
  //       if (id!=this.audio_id) {
  //         this.audio_id=id;
  //         this.audio_title=title;
  //         this.audio_url=url.replace(/^http:\/\//i, 'https://');
  //         this.load(this.audio_url);
  //       }
  //       else { this.canPlay(); }
  //     // si no hay id reconstruimos el objeto de audio
  //     } else {
  //       url = this.audio_url;
  //       title = this.audio_title;
  //       id = this.audio_id;
  //       this.canPlay();
  //     }
  //   // no existe un audio en uso
  //   } else if (this.audio_url=="" || id!=this.audio_id) {
  //     //reload sound
  //     this.audio_id=id;
  //     this.audio_title=title;
  //     this.audio_url=url;
  //     this.load(url);
  //   } else {
  //     this.canPlay();
  //   }
  // }

  canPlay() {
    this.audio_status = "canplay";
    var a = this.audio.play();
    try {
      if (a!==undefined) {
        a.then(_ => {
          this.initPlayer(this.audio_title,this.audio_id);
        }).catch(error=>{
          console.log(error)
          console.log("not possible to play")
          // show play button!!!
        });
      }
    } catch (e) {
      /* firefox & old browsers not use Observale*/
      this.initPlayer(this.audio_title,this.audio_id);
    }
  }

  initPlayer(title,id) {
    this.audio_title=title;
    this.audio_stopped = false;
    this.audio_paused = false;
    this.audio_id = id;
    //this.setAutoplay();
  }

  pause() {

    if (!this.audio_paused) {
      this.audio.pause();
    } else {
      this.audio.play();
    }
    this.audio_paused = !this.audio_paused;
    this._audio_is_playing.next(this.audio_paused);

  }

  mute() {
    this.audio.muted = !this.audio.muted;
  }

  stop() {
    this.audio.onloadstart = null;
    this.audio.oncanplay = null
    this.audio.onprogress = null;
    this.audio.pause();
    this.audio_buffered=-1
    this.audio.currentTime = 0;
    this.audio.removeAttribute('src');
    this.audio.load();
    this.audio_paused = true;
    this.audio_stopped = true;
    this.audio_id = 0;
    this.audio_url="";
    // Always playing
    this.play(environment.urlStream)
  }

  public isStopped():boolean {
    return this.audio_stopped;
  }

  public isPaused(id):boolean {
    if (id==this.audio_id) {
      return this.audio_paused;
    } else {
      return true;
    }
  }

  public getAudioID():number {
    return this.audio_id;
  }

  formatTime(seconds) {
    let minutes:any = Math.floor(seconds / 60);
    minutes = (minutes >= 10) ? minutes : "0" + minutes;
    seconds = Math.floor(seconds % 60);
    seconds = (seconds >= 10) ? seconds : "0" + seconds;
    return minutes + ":" + seconds;
  }

  setAutoplay() {
    this.audio.autoplay = true;
  }

  public getPercentDuration():number {
    return (this.audio.currentTime / this.audio.duration) * 100;
  }

  public setSeekPosition(rTime:number) {
    this.audio.currentTime = this.audio.duration * rTime;
  }

  handleStop() {
    this.stop();
  }

  handleEnded(e) {
    this.stop();
    this.audio_status = "finish";
  }

  handleTimeUpdate(e) {
    this.audio_status = "playing";
    let elapsed =  this.audio.currentTime;
    let duration =  this.audio.duration;


    if ( duration == Infinity || this.audio.src === environment.urlStream) duration=0;
    if (elapsed) {
    this.audio_position = elapsed / duration;
    this.audio_elapsed = this.formatTime(elapsed);
    this.audio_duration = this.formatTime(duration);
    this._audio_current_time.next({currentTime: this.formatTime(elapsed), duration: this.formatTime(duration)});
    }
  }

  handledCanPlay(e) {
    console.log(e)
    //play
  }

  handleWaiting() {
    this.audio_status = "waiting";
  }

  handleLoadMetadata(e) {
    console.log(e)
  }

  restart() {
    this._icy_metadata.next()
    this.play(environment.urlStream);

  }

}
